import { backendRequestScope, msalInstance } from "../authconfig";

export const acquireBackendToken = async (): Promise<string> => {
  if (!msalInstance || !backendRequestScope) {
    throw new Error("Authentication has not been initialized");
  }

  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) {
    throw new Error("No authenticated account found");
  }

  const { accessToken } = await msalInstance.acquireTokenSilent({
    ...backendRequestScope,
    account,
  });

  return accessToken;
};
